import React from 'react';

interface ComponentProps {
  fileData: any;
  fileType: any;
  fileName: any;
}

export const FilePreview: React.FC<ComponentProps> = ({ fileData, fileType, fileName }) => {
  if (fileType?.startsWith('image/')) {
    return <img src={fileData} alt={fileName} className="image" />;
  }

  if (fileType === 'application/pdf') {
    return (
      <object data={fileData} type="application/pdf" className="pdf" width="100%" height="500px">
        <p>
          Your browser does not support PDFs. <a href={fileData}>Download the PDF</a>
        </p>
      </object>
    );
  }

  return <div className="unsupported">Unsupported file type</div>;
};
